import React, { useEffect, useRef, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import SignOutButton from './SignOutButton';
import styled from 'styled-components';

const UserHeader = ({ userInfo }) => {
  const { accounts } = useMsal();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  useDismissOnOutsideClick(menuRef, setIsOpen);

  if (!userInfo || !accounts.length) {
    return null;
  }

  return (
    <HeaderContainer>
      <HeaderSpacer />
      <RightActions ref={menuRef}>
        <AvatarButton onClick={() => setIsOpen((v) => !v)} aria-haspopup="menu" aria-expanded={isOpen}>
          <UserAvatar>
            {userInfo.name ? userInfo.name.charAt(0).toUpperCase() : 'U'}
          </UserAvatar>
        </AvatarButton>
        {isOpen && (
          <Dropdown role="menu">
            <DropdownHeader>
              {/* <DropdownAvatar>
                {userInfo.name ? userInfo.name.charAt(0).toUpperCase() : 'U'}
              </DropdownAvatar> */}
              <DropdownDetails>
                <DropdownName>{userInfo.name || 'User'}</DropdownName>
                <DropdownEmail>{userInfo.email}</DropdownEmail>
              </DropdownDetails>
            </DropdownHeader>
            <DropdownFooter>
              <SignOutButton />
            </DropdownFooter>
          </Dropdown>
        )}
      </RightActions>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: transparent;
  border-bottom: none;
  box-shadow: none;
`;

const HeaderSpacer = styled.div``;

const RightActions = styled.div`
  margin-left: auto;
  position: relative;
`;

const AvatarButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #0078d4;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
`;

const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 280px;
  background: #ffffff;
  border: 1px solid #eef1f5;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  overflow: hidden;
  z-index: 100;
`;

const DropdownHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 12px 12px 12px;
  background: #f8fafc;
  border-bottom: 1px solid #eef1f5;
  text-align: center;
`;



const DropdownDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  text-align: center;
`;





const DropdownName = styled.div`
  font-weight: 700;
  color: #0b1220;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
`;

const DropdownEmail = styled.div`
  color: #6a7380;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
`;

const DropdownFooter = styled.div`
  padding: 10px 12px 12px 12px;
  display: flex;
  justify-content: center;
`;

// Close dropdown on outside click or Escape
const useDismissOnOutsideClick = (ref, setOpen) => {
  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [ref, setOpen]);
};

export default UserHeader;
